export default "__VITE_ASSET__u9HyBOVZxTZxptS5Y$qXog__"